import {
    SET_EXPECTED_PRICE,
    SET_SELECTED_PAYMENT_METHOD,
    SET_RESIDENT_DISCOUNT,
    TOGGLE_RESIDENT_DISCOUNT,
    SET_REPRICING_AMOUNT,
    SET_REPRICING_LOG,
} from 'od-modules/secure_store/actions';

export default function pricing(state = {}, action) {
    switch (action.type) {
        case SET_EXPECTED_PRICE:
            return Object.assign({}, state, {expectedPrice: action.entry});
        case SET_REPRICING_LOG:
            return Object.assign({}, state, {createShoppingCartRepricingValue: action.entry});
        case SET_REPRICING_AMOUNT:
            return Object.assign({}, state, {repricingAmount: action.entry});
        case SET_SELECTED_PAYMENT_METHOD:
            return Object.assign({}, state, {selectedPaymentMethod: action.entry});
        case SET_RESIDENT_DISCOUNT:
            return Object.assign({}, state, {residentDiscountApplied: action.entry});
        case TOGGLE_RESIDENT_DISCOUNT:
            return Object.assign({}, state, {residentDiscountApplied: !state.residentDiscountApplied});
        default:
            return state;
    }
}
